module.exports = "/_next/static/images/DataPipeline-17fa09ce71248d2cf711c96f165c1a87.webp";